/* Pro sample request: pick a formula, then three steps.

   LOCAL MOCK. There is no endpoint behind this. The final step swaps the form
   for a confirmation panel and logs the payload; wiring it to a real form
   service is a live-site job, not a mockup one.

   Progressive enhancement, deliberately. With JS off the fieldsets are all
   visible and the form is one long page that still reads and still tabs in
   order, and the pickers are ordinary checkboxes that still submit. The script
   is what collapses the form into steps and keeps the running summary, so
   nobody who blocks scripts gets a dead page.

   The pickers live up in the kit grid, OUTSIDE the <form>, because that grid is
   the media and the media should be the control rather than a second smaller
   copy of it further down. They still submit with the form: each one carries
   form="sample-form", which is what that attribute is for. */
(function () {
  'use strict';

  var form = document.getElementById('sample-form');
  if (!form) return;

  var picks = Array.prototype.slice.call(
    document.querySelectorAll('input[name="formulas"]'));

  /* "At least one of these five" is not expressible in native constraint
     validation. Marking every box required demands all five; marking one
     required demands that specific one. So this one rule is checked by hand,
     and it is checked in the two places a person can run into it: leaving the
     first step, and submitting. */
  function chosen() {
    return picks.filter(function (p) { return p.checked; })
                .map(function (p) { return p.dataset.name || p.value; });
  }

  var summary = document.getElementById('pick-summary');
  var mirror = document.getElementById('form-picks');
  var pickError = document.getElementById('pick-error');

  function words(list) {
    if (list.length === 1) return list[0];
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }

  function render() {
    var list = chosen();
    if (summary) {
      summary.textContent = list.length
        ? words(list)
        : 'Nothing selected yet.';
      summary.classList.toggle('is-empty', !list.length);
    }
    if (mirror) {
      mirror.textContent = list.length
        ? words(list) + (list.length === 1 ? '' : ', ' + list.length + ' cartridges')
        : 'Nothing selected yet.';
      mirror.classList.toggle('is-empty', !list.length);
    }
    if (list.length && pickError) pickError.hidden = true;
  }

  picks.forEach(function (p) { p.addEventListener('change', render); });

  /* Arriving from a product page with ?pick=<slug> ticks that formula on the way
     in. Without it the reader spends a page deciding which one they want, then
     lands on a five-way picker and has to decide again, which is the difference
     between a link and a flow.

     Only ids that already exist are honoured, so a stale or hand-edited slug is
     ignored rather than throwing. Multiple picks are allowed, since someone may
     have opened two product pages. */
  var wanted = (location.search.match(/[?&]pick=([^&]*)/) || [])[1];
  if (wanted) {
    wanted.split(',').forEach(function (slug) {
      var key = slug.replace(/[^a-z-]/gi, '');
      var box = document.getElementById('nbn-pick-' + key) || document.getElementById('pick-' + key);
      if (box && !box.checked) box.checked = true;
    });
  }

  render();

  function requirePick() {
    if (chosen().length) return true;
    if (pickError) pickError.hidden = false;
    var kit = document.getElementById('kit');
    if (kit) kit.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (picks[0]) picks[0].focus({ preventScroll: true });
    return false;
  }

  /* ------------------------------------------------------------------ steps */

  var steps = Array.prototype.slice.call(form.querySelectorAll('.fstep'));
  if (steps.length < 2) return;

  var counter = form.querySelector('.fcount');
  var bar = form.querySelector('.fbar span');
  var done = document.getElementById('sample-done');
  var at = 0;

  /* Native validity, so the browser supplies the messages and the required
     semantics rather than a bespoke half-implementation of both. */
  function valid(step) {
    var fields = step.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].checkValidity()) {
        fields[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  function show(n, focus) {
    at = n;
    steps.forEach(function (s, i) { s.hidden = i !== n; });
    if (counter) counter.textContent = 'Step ' + (n + 1) + ' of ' + steps.length;
    if (bar) bar.style.width = ((n + 1) / steps.length * 100) + '%';
    if (focus) {
      /* Move the caret to the top of the new step. The legend takes focus
         rather than the first input so a screen reader announces which step
         this is before it starts reading fields. */
      var h = steps[n].querySelector('legend');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      var top = form.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  form.addEventListener('click', function (e) {
    var next = e.target.closest('[data-next]');
    var back = e.target.closest('[data-back]');
    if (next) {
      e.preventDefault();
      if (at === 0 && !requirePick()) return;
      if (valid(steps[at])) show(Math.min(at + 1, steps.length - 1), true);
    } else if (back) {
      e.preventDefault();
      show(Math.max(at - 1, 0), true);
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!valid(steps[at])) return;
    if (!requirePick()) return;
    var fd = new FormData(form), data = {};
    fd.forEach(function (v, k) { if (k !== 'formulas') data[k] = v; });
    data.formulas = fd.getAll('formulas');       // a multi-value field, not a scalar
    var club = document.getElementById('caulk_club');
    data.caulk_club = !!(club && club.checked);  // a real boolean, not "yes"/absent
    /* Live: the same Google Form that takes the store's other sample requests
       (page.free-sample.liquid). It sends no CORS headers, so the response cannot
       be read; the request is fired and treated as sent, exactly as that page does. */
    var FORM_ACTION = 'https://docs.google.com/forms/d/e/1FAIpQLSdzJ5hzS33OuaITtRuxBADUwY-AJXt81lYyESfNW6RtFWPXdw/formResponse';
    var ENTRY = { name: 'entry.1532862529', company: 'entry.1667857411', email: 'entry.2133375614',
      phone: 'entry.200487374', street: 'entry.660555360', city: 'entry.1689690921', state: 'entry.731759759',
      zip: 'entry.118165668', crew: 'entry.1971050485', work: 'entry.1805453606', ref: 'entry.1493360150' };
    var params = new URLSearchParams(location.search);
    var values = {
      name: ((data.first_name || '') + ' ' + (data.last_name || '')).trim(),
      company: data.company || '',
      email: data.email || '',
      phone: data.phone || '',
      street: [data.address1, data.address2].filter(Boolean).join(', '),
      city: data.city || '', state: data.state || '', zip: data.zip || '',
      crew: [data.trade, data.volume].filter(Boolean).join(' / '),
      work: 'Formulas: ' + data.formulas.join(', ')
        + ' | Shop: ' + (data.shop_channel || '') + (data.shop_name ? ' (' + data.shop_name + ')' : '')
        + ' | Current brand: ' + (data.current_brand || '')
        + ' | Heard: ' + (data.heard || '')
        + ' | Contact: ' + (data.contact_pref || '') + (data.social ? ' ' + data.social : '')
        + ' | Caulk Club: ' + (data.caulk_club ? 'yes' : 'no'),
      ref: 'pro-samples ' + (params.get('r') || params.get('ref') || params.get('utm_source') || '')
    };
    var body = new URLSearchParams();
    Object.keys(values).forEach(function (k) { body.append(ENTRY[k], values[k]); });
    try { fetch(FORM_ACTION, { method: 'POST', mode: 'no-cors', body: body }); } catch (err) {}
    if (done) {
      var what = done.querySelector('#done-picks');
      if (what) what.textContent = words(chosen());
      /* The $5 line only appears if they actually joined. Showing it either way
         would promise a code to somebody who declined it. */
      var clubLine = document.getElementById('done-club');
      if (clubLine) clubLine.hidden = !data.caulk_club;
      form.hidden = true;
      done.hidden = false;
      done.setAttribute('tabindex', '-1');
      done.focus();
    }
  });

  /* Enter inside a step advances instead of submitting the whole form early.
     Without this, a browser fires submit from step one and the request goes
     out with two thirds of the fields empty. */
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target.tagName === 'TEXTAREA' || e.target.type === 'submit') return;
    if (at < steps.length - 1) {
      e.preventDefault();
      if (at === 0 && !requirePick()) return;
      if (valid(steps[at])) show(at + 1, true);
    }
  });

  form.classList.add('is-stepped');
  show(0, false);
}());
